<template>
  <div>
    <div v-for="facet in $props.facets" v-bind:key="facet.name">
      <template v-if="shouldDisplay(facet)">
        <p>
          {{ facet.label }} <span v-if="facet.required">(required)</span>
          <v-icon
            v-if="facet.description"
            v-b-tooltip.hover
            :title="facet.description"
            small
            color="gray"
            >fas fa-question-circle
          </v-icon>
        </p>

        <p v-if="facet.type === 'TEXT'">
          <b-form-input
            :required="facet.required"
            v-model="facetValues[facet.name]"
            :placeholder="facet.label"
          ></b-form-input>
        </p>

        <p v-if="facet.type === 'SELECT' && !('custom' in facet)">
          <b-form-select
            v-model="facetValues[facet.name]"
            :options="facet.options.map(facetOptionToSelectOption)"
            :placeholder="facet.label"
            :required="facet.required"
          ></b-form-select>
        </p>

        <p v-if="facet.type === 'MULTIPLE'">
          <b-alert show variant="light"
            >Hold CTRL (Windows) or Command (MacOS) key to select multiple
            options
          </b-alert>
          <b-form-select
            v-model="facetValues[facet.name]"
            :options="facet.options.map(facetOptionToSelectOption)"
            :placeholder="facet.label"
            multiple
            :select-size="5"
            :required="facet.required"
          ></b-form-select>
        </p>

        <p v-if="facet.type === 'HIER'">
          <JobTitlesAndFunctions
            return-type="id"
            :key="123"
            :mock-value="null"
            :initial-options="facet.options.map(facetOptionToHierOptions)"
            initial-options-type="hierarchical"
            v-model="facetValues[facet.name]"
            :required="facet.required"
          />
        </p>

        <p v-if="facet.type === 'TEXTEXPAND'">
          <vue-tags-input
            prepend="@"
            class="vue-tags-input"
            v-model="facetValues[facet.name]"
            placeholder="Type a value then hit Enter"
            :max-tags="$props.maxTags || 9999"
            :required="facet.required"
          ></vue-tags-input>
        </p>

        <p v-if="facet.type === 'DATE'">
          <b-form-datepicker
            v-model="facetValues[facet.name]"
            class="mb-2"
            :required="facet.required"
          ></b-form-datepicker>
        </p>

        <p v-if="facet.type === 'TEXTAREA'">
          <b-form-textarea
            id="textarea-auto-height"
            v-model="facetValues[facet.name]"
            :placeholder="facet.label + '...'"
            rows="3"
            max-rows="8"
            :required="facet.required"
          ></b-form-textarea>
        </p>

        <p
          v-if="
            facet.type === 'AUTOCOMPLETE' ||
              (facet.type === 'SELECT' && 'custom' in facet)
          "
        >
          autocomplete
          <MultiTags
            v-model="facetValues[facet.name]"
            :placeholder="facet.label + '...'"
            main_name_key="value"
            :search-param="
              'custom' in facet &&
              'params' in facet.custom &&
              facet.custom.params.includes('term')
                ? 'term'
                : null
            "
            search-method="post"
            :credentials="
              facet &&
              'custom' in facet &&
              'params' in facet.custom &&
              facet.custom.params.includes('credentials')
                ? $props.credentials
                : null
            "
            :max-tags="1"
            :autocomplete-endpoint="
              `/contracts/posting-requirements/${$props.channelId}/${facet.name}/`
            "
            :required="facet.required"
          ></MultiTags>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import JobTitlesAndFunctions from "@/view/content/forms/JobTitlesAndFunctions";
import VueTagsInput from "@johmun/vue-tags-input";
import MultiTags from "@/view/content/forms/MultiTags";

export default {
  name: "FacetsForm",
  props: ["facets", "channelId", "credentials", "value"],
  components: {
    JobTitlesAndFunctions: JobTitlesAndFunctions,
    VueTagsInput: VueTagsInput,
    MultiTags
  },
  methods: {
    facetOptionToSelectOption(facetOption) {
      return { value: facetOption.key, text: facetOption.label };
    },
    facetOptionToHierOptions(facetOption) {
      return {
        name: facetOption.labels?.default || facetOption.label,
        id: facetOption.key,
        parent: facetOption.parent
      };
    },
    checkOp(operation, operationValues, value) {
      if (operation == "equal") {
        return value == operationValues;
      } else if (operation == "in") {
        return operationValues.includes(value);
      } else if (operation === "notempty") {
        if (typeof value === "string") {
          return value.trim() !== "";
        } else if (Array.isArray(value)) {
          return value.length > 0;
        } else if (typeof value === "object") {
          return Object.keys(value).length > 0;
        } else {
          return !!value;
        }
      }
      return false;
    },
    shouldDisplay(data) {
      if (!data.display_rules?.show?.length) return true;
      const foundRule = data.display_rules.show.findIndex(rule => {
        const facetCheckValue = this.facetValues[rule.facet];
        if (facetCheckValue === undefined) return false;
        return this.checkOp(rule.op, rule.value, facetCheckValue);
      });
      return foundRule != -1;
    }
  },
  computed: {
    facetValues: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style scoped></style>
